import { useState } from 'react';

export const useCloseCallback = () => {
  const [closeItem, setCloseItem] = useState<() => void>(
    () => {
    });
  const closeItemCallback = (func: (e: Event) => void) => {
    setCloseItem(() => func);
  };

  return { closeItem, closeItemCallback };
};
